import { render, staticRenderFns } from "./WealthTemaplteMenuLinksMod.vue?vue&type=template&id=40f5c88e"
import script from "./WealthTemaplteMenuLinksMod.vue?vue&type=script&lang=js"
export * from "./WealthTemaplteMenuLinksMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports